import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Last line of defense: any uncaught render error used to leave a silent white
// page. This shows a minimal message with a reload button instead.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", gap: 16, color: "#e5e7eb", background: "#191c24", fontFamily: "sans-serif", padding: 24, textAlign: "center" }}>
          <div style={{ fontSize: 18 }}>Da ist etwas schiefgelaufen.</div>
          <div style={{ fontSize: 13, color: "#9ca3af" }}>{String(this.state.error?.message || this.state.error)}</div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: "8px 16px", borderRadius: 6, border: "1px solid #3b82f6", background: "transparent", color: "#3b82f6", cursor: "pointer" }}
          >
            Neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
